(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discreet-auth"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Tab switching
    const tabs = document.querySelectorAll('.auth-tab');
    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        tabs.forEach((t) => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');

        const targetTab = this.getAttribute('data-tab');
        document.querySelectorAll('.auth-tab-content').forEach((content) => {
          content.style.display = 'none';
          content.classList.remove('active');
        });

        const activeContent = document.getElementById('auth-tab-' + targetTab);
        if (activeContent) {
          activeContent.style.display = 'block';
          activeContent.classList.add('active');
        }
      });
    });

    // Passkey submission verification
    const passkeyForm = document.getElementById('DiscreetPasskeyForm');
    const passkeyInput = document.getElementById('DiscreetPasskeyInput');
    if (passkeyInput) {
      passkeyInput.addEventListener('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '');
      });
    }
    if (passkeyForm && passkeyInput) {
      passkeyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        const pin = passkeyInput.value.trim();

        const feedback = document.getElementById('PasskeyFeedback');
        if (pin.length !== 6 || !/^\d+$/.test(pin)) {
          if (feedback) {
            feedback.style.display = 'block';
            feedback.textContent = 'Please enter a valid 6-digit access code.';
          }
          return;
        }

        const submitBtn = passkeyForm.querySelector('.discreet-auth-submit-btn');
        const textEl = submitBtn ? submitBtn.querySelector('.btn-text') : null;
        const originalText = textEl ? textEl.textContent : 'VERIFY PASSKEY';

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.style.opacity = '0.7';
          if (textEl) {
            textEl.textContent = 'VERIFYING KEY...';
          }
        }

        try {
          const userCode = Number(pin);
          const userObfuscated = userCode * 17 + 12345;
          const validHashesRaw = passkeyForm.getAttribute('data-valid-hashes');
          const validHashes = JSON.parse(validHashesRaw || '[]');

          if (validHashes.includes(userObfuscated)) {
            // Store the authenticated hash (as string)
            sessionStorage.setItem('discreet_auth_hash', String(userObfuscated));
            const rememberCheckbox = document.getElementById('RememberSession');
            if (rememberCheckbox && rememberCheckbox.checked) {
              localStorage.setItem('discreet_auth_hash', String(userObfuscated));
            } else {
              localStorage.removeItem('discreet_auth_hash');
            }

            if (textEl) {
              textEl.textContent = 'ACCESS GRANTED...';
            }

            setTimeout(function () {
              window.location.href = '/pages/discreet';
            }, 800);
          } else {
            // Re-enable form and show error
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.style.opacity = '1';
              if (textEl) {
                textEl.textContent = originalText;
              }
            }
            if (feedback) {
              feedback.style.display = 'block';
              feedback.textContent = 'Invalid access code. Please try again.';
            }
          }
        } catch (error) {
          console.error('Verification error:', error);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.style.opacity = '1';
            if (textEl) {
              textEl.textContent = originalText;
            }
          }
          if (feedback) {
            feedback.style.display = 'block';
            feedback.textContent = 'An error occurred during verification. Please try again.';
          }
        }
      });
    }

    // Email Form submission enhancement
    const emailForm = document.getElementById('DiscreetEmailForm');
    if (emailForm) {
      emailForm.addEventListener('submit', function () {
        const emailInput = document.getElementById('DiscreetEmailInput');
        const emailBody = document.getElementById('DiscreetEmailBody');
        if (emailInput && emailBody) {
          emailBody.value = emailInput.value + " has requested code for discreet product.";
        }

        const btn = document.getElementById('DiscreetSubmitBtn');
        if (btn) {
          const text = btn.querySelector('.btn-text');
          const spinner = btn.querySelector('.btn-spinner');
          const arrow = btn.querySelector('.btn-arrow');
          if (text) text.textContent = 'AUTHENTICATING...';
          if (spinner) spinner.style.display = 'inline-block';
          if (arrow) arrow.style.display = 'none';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.js-feature-add-to-cart');
    if (btn && btn.dataset.variantId) {
      if (btn.hasAttribute('disabled')) return;

      e.preventDefault();
      const variantId = btn.dataset.variantId;
      const shortDesc = btn.dataset.shortDescription || '';

      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.classList.add('is-status-state');
      btn.style.pointerEvents = 'none';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              _short_description: shortDesc,
            },
          }),
        });

        if (response.ok) {
          const item = await response.json();
          const handle = item.handle || (item.items && item.items[0] && item.items[0].handle);
          if (handle && window.removeFromWishlist) {
            window.removeFromWishlist(handle);
          }
          btn.textContent = 'Added!';
          if (window.refreshCartDrawer) await window.refreshCartDrawer();
          if (window.openCartDrawer) window.openCartDrawer();

          setTimeout(() => {
            btn.textContent = originalText;
            btn.classList.remove('is-status-state');
            btn.style.pointerEvents = 'auto';
          }, 2000);
        } else {
          // Fallback to product page if AJAX fails
          window.location.href = btn.href;
        }
      } catch (error) {
        window.location.href = btn.href;
      }
      return;
    }

    // Section redirect logic
    const section = e.target.closest('.feature-section');
    if (section && section.dataset.link) {
      const isButton = e.target.closest('.feature-button');
      const isBookmark = e.target.closest('.feature-bookmark');

      if (!isButton && !isBookmark) {
        window.location.href = section.dataset.link;
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
